module.exports = __webpack_public_path__ + "static/media/saka_text_06.40882496.jpg";